<template>
    <div class="submit-pay">
        <div class="total-money">
            <span class="total">合计：</span>
            <span class="money"><span class="flag">¥</span>{{money}}</span>
        </div>
		<slot></slot>
        <div class="submit" @click="submit">{{step}}</div>
    </div>
</template>

<script>
    export default {
		props:{
			money:{
				type: String,
			},
			step:{
				type: String,
			},
		},
        name: 'submitPay',
        methods: {
			submit(){
				this.$emit("submitClick")
			}
        },
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    .submit-pay{position: fixed;bottom: 0;left: 0;/* width: 375px; */width: 100%;height: 60px;display: -webkit-box;display: -ms-flexbox;display: flex;align-items: center;background: #fff}
    .total-money{flex: 1;height:60px;line-height: 60px;padding-left:25px}
    .total{color:rgba(153,153,153,1);font-size: 13px;font-weight:400;font-family:PingFangSC-Regular,PingFang SC;display: inline-block;vertical-align: middle;}
	.money{color:rgba(65,132,244,1);font-size:14px;display: inline-block;vertical-align: middle;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;}
    .flag{font-size: 10px}
    .submit{color:rgba(255,255,255,1);font-size: 18px;background:rgba(65,132,244,1);height: 60px;width: 140px;text-align:center;line-height: 60px}
</style>
